import { Outlet } from 'react-router-dom'
import { LayoutProvider, useLayoutContext } from '@/context/layout.context'
import { Sidebar } from './Sidebar'
import { Header } from './Header'
import { Footer } from './Footer'

export function AppLayout() {
  return (
    <LayoutProvider>
      <AppLayoutContent />
    </LayoutProvider>
  )
}

function AppLayoutContent() {
  const { isMobileOpen, closeMobile } = useLayoutContext()

  return (
    <div className="flex h-screen overflow-hidden bg-background">
      {/* Mobile backdrop */}
      {isMobileOpen && (
        <div
          className="fixed inset-0 z-40 bg-black/50 lg:hidden"
          onClick={closeMobile}
          aria-hidden="true"
        />
      )}

      <Sidebar />

      <div className="flex min-w-0 flex-1 flex-col overflow-hidden">
        <Header />
        <main id="main-content" className="flex-1 overflow-y-auto p-6" tabIndex={-1}>
          <Outlet />
        </main>
        <Footer />
      </div>
    </div>
  )
}
